// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__MuYn1","list":"styles_list__1H7-d"};